module.exports = __webpack_public_path__ + "img/行政 (2).f1688052.jpg";